export const planDetails = [
  {
    checkbox: true,
    plan: "Basic",
    plan_type:"Monthly",
    created_date: "14 Jan 2024",
    modified_date: "20 Feb 2024",
    amount: "$50",
    subscribed_user: "30 Users",
    key: "1"
  },
  {
    checkbox: true,
    plan: "Professional",
    plan_type:"Monthly",
    created_date: "21 Feb 2024",
    modified_date: "11 Mar 2024",
    amount: "$100",
    subscribed_user: "40 Users",
    key: "2"
  },
  {
    checkbox: true,
    plan: "Enterprise",
    plan_type:"Monthly",
    created_date: "18 Mar 2024",
    modified_date: "05 Apr 2024",
    amount: "$200",
    subscribed_user: "50 Users",
    key: "3"
  },
];
